export function NotesSection({ notes }: { notes: string; }) {
    return (
        <div className="flex flex-col justify-between dashboard-notes-card rounded-md ">
            <p className="indent-2 italic text-base">"{notes ? notes : '(no notes written...)'}"</p>
        </div>
    )
}